import { B2BError } from "../../ui/error/B2BError"
import { B2BContentModel } from "../models/B2BContentModel"
import { Endpoint } from "../network/endpoint"
import { HttpManager } from "../network/interface/HttpManager"

export class B2BService {
	private _http: HttpManager

	constructor({ HttpManager }: { HttpManager: HttpManager }) {
		this._http = HttpManager
	}

	public async getB2BContent(): Promise<B2BContentModel[]> {
		try {
			const response = await this._http.requestNewApi({
				method: "GET",
				url: Endpoint.B2B_CONTENT
			})
			return response.data.map(B2BContentModel.fromRawJson)
		} catch (error: any) {
			throw new B2BError({
				errorMessage: B2BError.B2B_FETCH_ERROR,
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}

	public async updateB2BTexts(content: B2BContentModel[]): Promise<void> {
		try {
			await this._http.requestNewApi({
				method: "PUT",
				data: content,
				url: Endpoint.B2B_CONTENT
			})
		} catch (error: any) {
			throw new B2BError({
				errorMessage: B2BError.B2B_UPDATE_ERROR,
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}

	public async updateB2BImage(imageName: string, files: { image: File; locale: string }[]): Promise<string> {
		try {
			const formData = new FormData()
			for (const file of files) {
				formData.append(file.locale, file.image)
			}
			const response = await this._http.requestNewApi({
				method: "PUT",
				headers: {
					"Content-Type": "multipart/form-data"
				},
				data: formData,
				url: `${Endpoint.B2B_CONTENT}/${imageName}`
			})
			return response.data
		} catch (error: any) {
			throw new B2BError({
				errorMessage: B2BError.B2B_UPDATE_ERROR,
				errorCode: error?.error_msg,
				httpStatus: error?.httpStatus
			})
		}
	}
}
